import React, { useEffect, useState } from 'react';
import MyConstant from '../../config/MyConstant';
import { analyticsUserTrack } from '../../config/analyticsTrack';

let country = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua & Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia & Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo",
    "Congo Democratic Republic",
    "Cook Islands",
    "Costa Rica",
    "Cote d'Ivoire",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "East Timor",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Holy See",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea North",
    "Korea South",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macedonia",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar (Burma)",
    "Namibia",
    "Nauru",
    "Nepal",
    "The Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "The Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "St. Kitts & Nevis",
    "St. Lucia",
    "St. Vincent & The Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome & Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Togo",
    "Tonga",
    "Trinidad & Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States of America",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe"
]

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const SignForm = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        country: 'United States of America',
        email: '',
        subscribe: true,
        profession: '',
        retired: false
    });

    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);

    useEffect(() => {
        isValid()
    }, [formData])

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === "retired") {
            setFormData(prev => ({
                ...prev,
                [name]: type === 'checkbox' ? checked : value,
                profession: checked ? "Retired" : ""
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: type === 'checkbox' ? checked : value
            }));
        }
    };

    function isValid() {
        let errors = {}

        if (!formData.firstName.trim()) {
            errors.firstName = "First Name is required."
        }
        if (!formData.lastName.trim()) {
            errors.lastName = "Last Name is required."
        }
        if (!formData.email.trim()) {
            errors.email = "Email is required."
        }
        if (!emailRegex.test(formData.email)) {
            errors.email = "Email is not valid."
        }
        if (!formData.profession.trim()) {
            errors.profession = "Organization / Profession is required."
        }
        if (!formData.subscribe) {
            errors.subscribe = "Required."
        }

        setErrors(errors)
        return Object.keys(errors).length === 0
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitted(true);

        if (isValid()) {
            setButtonLoader(true)
            let uniqId = 'id-' + (new Date()).getTime() + Math.random().toString(36).substr(2);
            //http://192.168.1.7:8091/ght-api/contact
            
            try {
                const response = await fetch(`https://api.teqbahn.com/ght-api/contact`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ ...formData, reqId: uniqId }),
                });
                if (response.ok) {
                    alert('Thank you for your message! We will get back to you soon.');
                    analyticsUserTrack("GHT", "Form Submitted");
                    setFormData({
                        firstName: '',
                        lastName: '',
                        country: 'United States of America',
                        email: '',
                        subscribe: true,
                        profession: '',
                        retired: false
                    })
                    setSubmitted(false);
                    setButtonLoader(false)
                } else {
                    throw new Error('Failed to send message');
                }
            } catch (error) {
                setSubmitted(false);
                setButtonLoader(false)
                alert('Sorry, there was an error sending your message. Please try again later.');
            }
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="form-row">
                <div className="form-group col-md-6 px-0">
                    <label>First Name</label>
                    <input
                        type="text"
                        className={`form-control ${submitted && !formData.firstName ? 'is-invalid' : ''}`}
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                    />
                    {submitted && errors.firstName && (
                        <small className='invalid-feedback'>{errors.firstName}</small>
                    )}
                </div>

                <div className="form-group col-md-6 pr-0">
                    <label>Last Name</label>
                    <input
                        type="text"
                        className={`form-control ${submitted && !formData.lastName ? 'is-invalid' : ''}`}
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                    />
                    {submitted && errors.lastName && (
                        <small className='invalid-feedback'>{errors.lastName}</small>
                    )}
                </div>
            </div>

            <div className="form-group">
                <label>Country</label>
                <select className="form-control" name="country" value={formData.country} onChange={handleChange}>
                    {
                        country.map((item, index) => {
                            return <option key={index} value={item} >{item}</option>
                        })
                    }
                </select>
            </div>

            <div className="form-group">
                <label>Email</label>
                <input
                    type="email"
                    className={`form-control ${submitted && (!formData.email || !emailRegex.test(formData.email)) ? 'is-invalid' : ''}`}
                    name="email"
                    placeholder="email@email.com"
                    value={formData.email}
                    onChange={handleChange}
                />
                {submitted && errors.email && (
                    <small className='invalid-feedback'>{errors.email}</small>
                )}
            </div>

            <div className="form-check mb-3">
                <input
                    className="form-check-input"
                    type="checkbox"
                    name="subscribe"
                    checked={formData.subscribe}
                    onChange={handleChange}
                />
                <label className={`form-check-label ml-2`} style={{ color: (submitted && errors.subscribe) ? "#dc3545" : "#4A4A4A" }}>
                    Yes, I confirm my subscription to the mailing list.
                </label>
            </div>

            <div className="form-group">
                <label>Organization / Profession</label>
                <input
                    type="text"
                    className={`form-control ${submitted && !formData.profession ? 'is-invalid' : ''}`}
                    name="profession"
                    value={formData.profession}
                    onChange={handleChange}
                />
                {submitted && errors.profession && (
                    <small className='invalid-feedback'>{errors.profession}</small>
                )}
                <div className="form-check mt-2">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        name="retired"
                        checked={formData.retired}
                        onChange={handleChange}
                    />
                    <label className="form-check-label ml-2">I am retired</label>
                </div>
            </div>

            <button type="submit" disabled={buttonLoader} className="btn btn-primary action-button">
                {buttonLoader && <i className="fa fa-spinner fa-spin"></i>}
                <span className={`${buttonLoader && ("pl-1")}`}>{"Click to Sign"}</span>
            </button>

            <div className='my-5'>
                <small>*By signing you will be added to our mailing list. You can choose to opt out from the signature confirmation email.</small>
            </div>
        </form>
    );
};

export default SignForm;
